export const SPORT_OPTIONS = [
  { value: 'skating', label: 'Ice Skating', slug: 'ice-skating' },
  { value: 'gymnastics', label: 'Gymnastics', slug: 'gymnastics' },
  { value: 'golf', label: 'Golf', slug: 'golf' },
  { value: 'tumbling', label: 'Tumbling', slug: 'tumbling' },
  { value: 'pickleball', label: 'Pickleball', slug: 'pickleball' },
  { value: 'tennis', label: 'Tennis', slug: 'tennis' },
  { value: 'swimming', label: 'Swimming', slug: 'swimming' },
  { value: 'soccer', label: 'Soccer', slug: 'soccer' },
  { value: 'basketball', label: 'Basketball', slug: 'basketball' },
  { value: 'baseball', label: 'Baseball', slug: 'baseball' },
  { value: 'volleyball', label: 'Volleyball', slug: 'volleyball' },
  { value: 'martial_arts', label: 'Martial Arts', slug: 'martial-arts' },
  { value: 'dance', label: 'Dance', slug: 'dance' },
  { value: 'cheerleading', label: 'Cheerleading', slug: 'cheerleading' },
  { value: 'track_and_field', label: 'Track & Field', slug: 'track-and-field' },
  { value: 'football', label: 'Football', slug: 'football' },
  { value: 'lacrosse', label: 'Lacrosse', slug: 'lacrosse' },
  { value: 'wrestling', label: 'Wrestling', slug: 'wrestling' },
  { value: 'fencing', label: 'Fencing', slug: 'fencing' },
  { value: 'rowing', label: 'Rowing', slug: 'rowing' },
  { value: 'climbing', label: 'Climbing', slug: 'climbing' },
  { value: 'other', label: 'Other', slug: 'other' }
]

export function getSportLabel(value, customSportName) {
  if (value === 'other' && customSportName) {
    return customSportName
  }
  const sport = SPORT_OPTIONS.find((s) => s.value === value)
  return sport ? sport.label : value
}

export function getSportBySlug(slug) {
  return SPORT_OPTIONS.find((s) => s.slug === slug)
}

export function getSportByValue(value) {
  return SPORT_OPTIONS.find((s) => s.value === value)
}

export function getAllSportSlugs() {
  return SPORT_OPTIONS.filter((s) => s.value !== 'other').map((s) => s.slug)
}
